module.exports = __webpack_public_path__ + "assets/img/dzh-36.1deffaac.jpg";